import styled from 'styled-components';
import React, { useRef, useEffect, useState } from 'react';
import { MQS } from '../app/common/constants/styles';

const ExternalHTMLFooterWrapper = styled.div`
    width: 100%;
    max-width: 1080px;
`;

const FooterIframe = styled.iframe`
    width: 100%;
    height: 100px;
    @media (max-width: ${MQS.mq2Max}) {
        height: 305px;
    }
`;
export default ({ externalHTMLFooter }) => {
    const ref = useRef();
    const [src, setSrc] = useState('');

    useEffect(() => {
        if (externalHTMLFooter) {
            setSrc(externalHTMLFooter);
        }
    }, [externalHTMLFooter]);
    return (
        <ExternalHTMLFooterWrapper>
            {externalHTMLFooter ? (
                <FooterIframe
                    src={src}
                    innerRef={ref}
                    frameBorder="0"
                    marginHeight="0"
                    marginWidth="0"
                    sandbox="allow-popups allow-popups-to-escape-sandbox allow-top-navigation allow-forms allow-scripts allow-top-navigation-by-user-activation "
                    title="External services"
                />
            ) : (
                <></>
            )}
        </ExternalHTMLFooterWrapper>
    );
};
